export const USER_UPDATE_CONNECTED = 'USER_UPDATE_CONNECTED'
export const USER_UPDATE_INFOS = 'USER_UPDATE_INFOS'
export const USER_UPDATE_PAYMENT_METHOD = 'USER_UPDATE_PAYMENT_METHOD'
